import templateUrl from './transportation-alternatives-page-template2.html';

export const transportationAlternativesPageTemplate2Component = {
	templateUrl,

	bindings: {
		details: '<',
		paginationDetails: '<',
		onPageChange: '&',
		onCountyChange: '&'
	},

	controller: class TransportationAlternativesPageTemplate2Component {
		constructor(ApiService) {
			'ngInject';

			this.apiService = ApiService;
		}

		_onPageChange(pageNumber) {
			return this.onPageChange({
				$event: pageNumber
			});
		}

		_getImage(report) {
			const image = report.image;
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '/./images/placeholder.png';
		}
		
		showText(text, index) {
			const showReadMore = 'showReadMore' + index;	
			return this[showReadMore] = text.length > 400 ? true : false;
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/transportation-alternatives-page-template2/transportation-alternatives-page-template2.component.js